export const themeColor = {
    'app-theme-dark': {
        "--font-weight": "lighter",
        "--background-default": "#1f1f00",
        "--background-toolbar": "#191919",
        "--background-color1": "#3e3e3e",
        "--background-color2": "#1e1e1e",
        "--background-color3": "#2c2c2c",
        "--background-color4": "#2b2b2b",
        "--background-color5": "#4b4b4b",
        "--background-color6": "#191919",
        "--background-color7": "#272727",
        "--background-color8": "#252525",
        "--background-color9": "#303030",
        "--background-color10": "#d0d0d0",
        "--background-color11": "#444444",
        "--background-color12": "#393939",
        "--background-color13": "#6f6f6f",
        "--background-color14": "#000000",
        "--background-color15": "#d5d5d5",
        "--background-color16": "#333333",
        "--background-color17": "#1D1D1D",
        "--background-color18": "#4a4a4a",
        "--background-color19": "#121212",
        "--background-login": "#222",
        "--background-body": "#313131",
        "--background-default1": "#03a9f4",
        "--background-default2": "#03a9f4",
        "--background-default3": "#201f1f",
        "--background-default4": "#03a9f4",
        "--background-fc": "#2C3E50",
        "--background-fc1": "#1a252f",
        "--background-button1": "#d5d5d5",
        "--background-button2": "#3a5797",
        "--background-red": "#ff0000",
        "--background-green": "#04f70a",
        "--background-blue": "#4170ff",
        "--background-selector": "rgba(255, 0, 0, 0.1)",
        "--background-timeline": "#1f1f00",
        "--background-timeline1": "#2d2d2d",
        "--background-scrollbar": "#191919",

        "--border-selector": "#03a9f4",
        "--drop-shadow": "#000000",
        "--station-up": "#1bb700",
        "--station-down": "#ff0000",
        "--station-poll": "#fff800",
        "--line-chart1": "#D8D8D8",
        "--line-chart2": "#C0D0E0",

        "--border-color1": "#191919",
        "--border-color2": "#212121",
        "--border-color3": "#ffffff",

        "--text-color1": "#ffffff",
        "--text-color2": "#d5d5d5",
        "--text-color3": "#a9a9a9",
        "--text-color4": "#03a9f4",
        "--text-color5": "#747474",
        "--text-color6": "#212121",
        "--text-color7": "#e0e0e0",
        "--text-chat-global": "#adff2f",

        "--hover-color1": "#3b3b3b",
        "--hover-color2": "#ff6347",
        "--hover-color3": "#03a9f4",
        "--hover-color4": "#262626",
        "--hover-color5": "#878787",
        "--template-invert": 1,
        "--warn-color": "#f44336",
        "--warn-color2": "#03a9f4",

        "--main-theme-color": "#212121",
        "--custom-color1": "#555555",
        "--custom-color2": "#303030",

        "--video-progress-bg": "#ffffff",
        "--video-progress-fill": "#00a000",

        "--menu-button-active-color": "#505050"
    },
    'app-theme-light': {
        "--font-weight": "bolder",
        "--background-default": "#efefef",
        "--background-toolbar": "#0b1a70",
        "--background-color1": "#f0f0f0",
        "--background-color2": "#e1e1e1",
        "--background-color3": "#e7e7e7",
        "--background-color4": "#f1f1f1",
        "--background-color5": "#e5e5e5",
        "--background-color6": "#ffffff",
        "--background-color7": "#efefef",
        "--background-color8": "#ececec",
        "--background-color9": "#b0b0b0",
        "--background-color10": "#fefefe",
        "--background-color11": "#999999",
        "--background-color12": "#909090",
        "--background-color13": "#9ccbff",
        "--background-color14": "#d5d5d5",
        "--background-color15": "#6e6e6e",
        "--background-color16": "#333333",
        "--background-color17": "#709BFF",
        "--background-color18": "#5586fe",
        "--background-color19": "#5586fe",
        "--background-login": "#ffffff",
        "--background-body": "#ffffff",
        "--background-default1": "#3f51b5",
        "--background-default2": "#88acff",
        "--background-default3": "#709bff",
        "--background-default4": "#cadcf7",
        "--background-fc": "#88acff",
        "--background-fc1": "#6a90ff",
        "--background-button1": "#6f6f6f",
        "--background-button2": "#0d307e",
        "--background-red": "#ff0000",
        "--background-green": "#009321",
        "--background-blue": "#4170ff",
        "--background-selector": "rgba(0, 0, 255, 0.1)",
        "--background-timeline": "#aeaeae",
        "--background-timeline1": "#9f9f9f",
        "--background-scrollbar": "#9f9f9f",

        "--border-selector": "#0000ff",
        "--drop-shadow": "#ccc",

        "--line-chart1": "#9ba0a7",
        "--line-chart2": "#5e1a84",

        "--border-color1": "#83a3f1",
        "--border-color2": "#d0d0d0",
        "--border-color3": "#6a90ff",

        "--text-color1": "#000000",
        "--text-color2": "#444444",
        "--text-color3": "#5b5b5b",
        "--text-color4": "#0017ff",
        "--text-color5": "#212121",
        "--text-color6": "#ffffff",
        "--text-color7": "#242424",
        "--text-chat-global": "#02adff",

        "--hover-color1": "#88acff",
        "--hover-color2": "#adc7fd",
        "--hover-color3": "#88acff",
        "--hover-color4": "#d2eaff",
        "--hover-color5": "#4d6ba5",
        "--template-invert": 0.4,
        "--warn-color": "#a0a0a0",
        "--warn-color2": "#f44336",
        "--station-up": "#189900",
        "--station-down": "#ff0000",
        "--station-poll": "#c7c213",
        "--main-theme-color": "#3f51b5",
        "--custom-color1": "#d1d1d1",
        "--custom-color2": "#fafafa",

        "--video-progress-bg": "#808080",
        "--video-progress-fill": "#00f000",

        "--menu-button-active-color": "#e7e7e7"
    },
    'app-theme-gradient': {
        "--font-weight": "normal",
        "--background-default": "#040a1b",
        "--background-toolbar": "#390015",
        "--background-color1": "#040a1b",
        "--background-color2": "#0a1428",
        "--background-color3": "#040a1b",
        "--background-color4": "#0a1428",
        "--background-color5": "#040a1b",
        "--background-color6": "#0f172b",
        "--background-color7": "#040a1b",
        "--background-color8": "#0a1428",
        "--background-color9": "#040a1b",
        "--background-color10": "#e94560",
        "--background-color11": "#323e61",
        "--background-color12": "#0a1428",
        "--background-color13": "#e94560",
        "--background-color14": "#000000",
        "--background-color15": "#e94560",
        "--background-color16": "#0f172b",
        "--background-color17": "#0a1428",
        "--background-color18": "#040a1b",
        "--background-color19": "#000000",
        "--background-login": "#040a1b",
        "--background-body": "#030510",
        "--background-default1": "#e94560",
        "--background-default2": "#e94560",
        "--background-default3": "#040a1b",
        "--background-default4": "#e94560",
        "--background-fc": "#040a1b",
        "--background-fc1": "#040a1b",
        "--background-button1": "#e94560",
        "--background-button2": "#040a1b",
        "--background-red": "#ff0066",
        "--background-green": "#00ff88",
        "--background-blue": "#0066ff",
        "--background-selector": "rgba(233, 69, 96, 0.2)",
        "--background-timeline": "#040a1b",
        "--background-timeline1": "#0a1428",
        "--background-scrollbar": "#0a1428",

        "--border-selector": "#e94560",
        "--drop-shadow": "#000000",
        "--station-up": "#00ff88",
        "--station-down": "#ff0066",
        "--station-poll": "#ffaa00",
        "--line-chart1": "#e94560",
        "--line-chart2": "#040a1b",

        "--border-color1": "#0a1428",
        "--border-color2": "#040a1b",
        "--border-color3": "#e94560",

        "--text-color1": "#ffffff",
        "--text-color2": "#e0e0e0",
        "--text-color3": "#b0b0b0",
        "--text-color4": "#e94560",
        "--text-color5": "#808080",
        "--text-color6": "#0a1428",
        "--text-color7": "#f0f0f0",
        "--text-chat-global": "#00ffaa",

        "--hover-color1": "#040a1b",
        "--hover-color2": "#e94560",
        "--hover-color3": "#e94560",
        "--hover-color4": "#040a1b",
        "--hover-color5": "#040a1b",
        "--template-invert": 0.8,
        "--warn-color": "#ff0066",
        "--warn-color2": "#e94560",

        "--main-theme-color": "#040a1b",
        "--custom-color1": "#0a1428",
        "--custom-color2": "#040a1b",

        "--video-progress-bg": "#ffffff",
        "--video-progress-fill": "#00ff88",

        "--menu-button-active-color": "#040a1b"
    }
};
